export function hasValue($val) {
  return $val != null && $val.toString().trim() != "" ? true : false;
}

export function referToSection(ref) {
  ref.current.scrollIntoView({ behavior: "smooth" });
}
